import dateFns from 'date-fns'

import CoreResize from '../../mixins/core-resize'
import AppPage from '../../mixins/app-page'

import AppTitle from '../app-title'
import AppBtnShare from '../app-btn-share'
import AppBtnFilter from '../app-btn-filter'
import AppImgBg from '../app-img-bg'
import AppImg from '../app-img'
import AppResume from '../app-resume'
import AppFadein from '../app-fadein'
import AppBtn from '../app-btn'


// URL list
import URL from '../../../config.url'


function pushToGTM(data)
{
    if (window.dataLayer)
    {
        window.dataLayer.push(data)
    }
    else
    {
        console.error('Google Tag Manager: dataLayer not defined')
    }
}


export default
{
    name: 'page-videos',

    mixins:
    [
        AppPage,
        CoreResize
    ],

    components:
    {
        AppTitle,
        AppBtnShare,
        AppImgBg,
        AppImg,
        AppResume,
        AppFadein,
        AppBtnFilter,
        AppBtn
    },

    watch:
    {
        contentPage: '_sortVideos',
        params: '_setCoverVideoByParam'
    },

    data()
    {
        return {
            currentCoverData: null,

            pageURL: URL.page,
            videos: [],
            currentFilterId: 3,
            columnLength: 0,
            isMoreBtnEnable: false,
            games: this.contentGlobal.videoGames,
            coverVideos: this.contentPage.coverVideos,
            numberOfCoverVideos: 0
        }
    },

    created()
    {
        for (let i = 0, l = this.coverVideos.length; i < l; i += 1)
        {
            const coverVideos = this.coverVideos[i]

            for (let j = 0, m = this.games.length; j < m; j += 1)
            {
                const game = this.games[i]

                if (coverVideos.jwPlayerFile && coverVideos.jwPlayerFile.trim() !== '')
                {
                    this.numberOfCoverVideos += 1
                    game.video = coverVideos.jwPlayerFile
                }
                else
                {
                    game.video = null
                }
            }
        }

        this._moreVideos()
        this._sortVideos()
    },

    mounted()
    {
        this.eventHub.$emit('bg-change', '/static/bg/bg-videos.jpg')
        this._jwPlayerElmt = this.$el.querySelector('.js-jwplayer')

        if (this.numberOfCoverVideos > 0) this._setCoverVideoByParam()
    },

    destroyed()
    {
        if (this._playerInstance)
        {
            this._jwPlayerRemoveEvents(this._playerInstance)
            this._playerInstance.remove()
        }
    },

    methods:
    {
        onResized()
        {
            this._sortVideos()
        },


        // +---------------------------------+
        //      COVER VIDEOS

        _setCoverVideoByParam()
        {
            let gameId = this.games[0].id

            if (this.params.filter)
            {
                gameId = this.games.find(game => game.slug === this.params.filter && game.video !== null).id
            }
            else
            {
                gameId = this.games.find(game => game.video !== null).id
            }

            this.changeCoverVideo(gameId)
        },

        changeCoverVideo(id = this.currentCoverData.id)
        {
            this.currentCoverData = this.contentPage.coverVideos.find(data => parseInt(data.videoGameID, 10) === parseInt(id, 10))

            const jwplayer = window.jwplayer
            if (jwplayer)
            {
                const videoData = this.currentCoverData
                if (!this._playerInstance)
                {
                    this._playerInstance = window.jwplayer(this._jwPlayerElmt)
                    this._playerInstance = this._playerInstance.setup({
                        file: videoData.jwPlayerFile,
                        mediaid: videoData.lDFxMvpn
                    })
                }
                else
                {
                    this._jwPlayerRemoveEvents(window.jwplayer(this._jwPlayerElmt))
                    this._playerInstance.load({
                        file: videoData.jwPlayerFile,
                        mediaid: videoData.lDFxMvpn
                    })
                }

                this._jwPlayerAddEvents(window.jwplayer(this._jwPlayerElmt))

                this.$nextTick(() => this.$emit('load', this))
            }
            else
            {
                console.error('JWPLAYER not found')
            }
        },

        _jwPlayerAddEvents(player)
        {
            const label = player.getConfig().file
            const send = action =>
            {
                pushToGTM({
                    event: 'gfinity.video',
                    'gfinity.video.action': action,
                    'gfinity.video.resource': label
                })
            }

            player.on('play', () => send('play'))
            player.on('pause', () => send('pause'))
            player.on('complete', () => send('ended'))
            player.on('remove', () => send('close'))
        },

        _jwPlayerRemoveEvents(player)
        {
            player.stop()
            pushToGTM({
                event: 'gfinity.video',
                'gfinity.video.action': 'close',
                'gfinity.video.resource': player.getConfig().file
            })

            player.off('play')
            player.off('pause')
            player.off('complete')
            player.off('remove')
        },

        getVideoGameFromID(id)
        {
            return this.contentGlobal.videoGames.find(videoGame => videoGame.id === id)
        },


        // +---------------------------------+
        //      MORE VIDEOS

        getVideoUrlBySlug(slug)
        {
            return URL.page.videoPlayer.replace(':slug', slug)
        },

        filter(num)
        {
            if (this.currentFilterId !== null)
            {
                this.columnLength = 0
                this._moreVideos()

                this.currentFilterId = num
                this._sortVideos()
            }
        },

        getTypeById(id)
        {
            return this.contentGlobal.postTypes.find(type => type.id === id)
        },

        getFormatDate(timestamp)
        {
            return dateFns.format(timestamp * 1000, 'DD[.]MM[.]YYYY [—] h[:]mm[<sup>]a[</sup>]')
        },

        _moreVideos()
        {
            this.columnLength += 3
            this._moreCheck()
        },

        _moreCheck()
        {
            let isMoreBtnEnable = false
            const columnLength = this.columnLength

            for (const column of this.videos)
            {
                if (column.length > columnLength)
                {
                    isMoreBtnEnable = true
                }
            }

            this.isMoreBtnEnable = isMoreBtnEnable
        },

        _shorten(text, length)
        {
            if (text.length > length)
            {
                text = text.substr(0, length - 3)
                text = text.substr(0, Math.min(text.length, text.lastIndexOf(' '))) + '...'
            }

            return text
        },

        _sortVideos()
        {
            const videosOriginal = JSON.parse(JSON.stringify(this.contentPage.list))
            const columnNum = Math.min(Math.max(Math.floor(this.resize.width / 500), 1), 3)

            const videos = []
            const currentTypeId = this.getTypeById(this.currentFilterId).id

            videos.length = 0

            let i = 0
            while (videosOriginal.length > 0)
            {
                const video = videosOriginal.shift()
                video.key = videosOriginal.length

                if (video.type.indexOf(currentTypeId) > -1)
                {
                    const columnId = ((i++) % columnNum)

                    if (!videos[columnId])
                    {
                        videos[columnId] = []
                    }

                    videos[columnId].push(video)
                }
            }

            this.videos = videos
            this._moreCheck()

            this.$nextTick(() => this.$emit('load', this))
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-videos/script.js